
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import {
		profitStatisticList,
		profitStatisticprofitStatisticTotal
	} from '@/api/statistic'

	import PickerDate from '@/components/picker-date.vue';
	import PageFooter from '@/components/page-footer.vue';
	import detailDialog from './components/detail-dialog.vue';
	import serviceDialog from './components/service-dialog.vue';
	import Dialog from '@/components/dialog.vue';
	
	import {
		productpopoverproductlist
	} from '@/api/material'
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"
	import axios from 'axios';
	@Component({
		name: 'profit-statistic',
		components: {
			PickerDate,
			PageFooter,
			detailDialog,
			serviceDialog,
			'slz-dialog': Dialog,
		}
	})
	export default class ProfitStatistic extends Vue {
		private loading = false;
		private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private isCompany = null;
		private filterTime = ''
		private selectList: any = [
			{
				value: null,
				label: '全部'
			}, {
				value: true,
				label: '是'
			}, {
				value: false,
				label: '否'
			}
		];
		private grade = null
		private gradelist = [
			{
				label: '全部',
				value: null
			}, {
				label: '联创',
				value: 1
			}, {
				label: '核心',
				value: 2
			}, {
				label: '总代',
				value: 3
			}
		]
		private visible = false;
		private selected:any = {};
		private serviceShow=false

		private shopIdList:any = []
		private shopindex = 1
		private lastkeywords = ''
		private shoplist:any = []
		private totalShow = false
		private totalMsg:any = {}


		private created() {
			this.initTime()
			this.getList()
			this.geteasyProductList()
		}

		
		private initTime(){
			this.filterTime = [getSearchDate(2,false,-6)[0],getSearchDate(2)[0]].join('/')
		}




		private lookTotal(){
			this.totalShow = true
			this.getTotal()
		}
		private async getTotal(){

			try{
					let params: any = {
					Keywords: this.keywords,
					IsCompany: this.isCompany,
					RoleGrade:this.grade,
					ProductIdList:this.shopIdList
				}
				if (this.filterTime) {
					var dt = this.filterTime.split('/');
					params.StartTime = dt[0];
					params.EndTime = nextDay(dt[1],1);
				}
				let res = await profitStatisticprofitStatisticTotal(params)
				if(res.IsSuccess){
					this.totalMsg = res.Result
				}
			}finally{
				//
			}
		}
		private touchbottom(){
			this.shopindex++
			this.geteasyProductList(this.lastkeywords)
		}
		private async geteasyProductList(keywords?:string) {
			if((keywords&&keywords!=this.lastkeywords)||(this.lastkeywords&&!keywords)){
				this.shopindex = 1
				this.shoplist = []
				this.lastkeywords = keywords
			}
			const params: any = {
				Skip: (this.shopindex-1)*20,
				Take: 20,
				Keywords:keywords
			}
			try {
				const res: any = await productpopoverproductlist(params)
				if (res.IsSuccess) {
					this.shoplist = [...this.shoplist,...res.Result.Results];
				} 
			} finally{
				//
			}
		}
		private servicefee(e){
			this.selected = e
			this.serviceShow = true;
		}

		
		private exportlist(){
			var url = location.origin + '/pc/profitStatistic/serviceFeeAllExport?';
			url += 'Keywords=' + (this.keywords?this.keywords:'');
			url += '&IsCompany=' + (this.isCompany!==null?this.isCompany:'');
			url += '&RoleGrade=' + (this.grade!==null?this.grade:'');
			
			
			if (this.filterTime && this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + nextDay(dt[1],1);
			}
			
			window.open(url)
		}

		private changePage(e) {
			this.pageNo = +e;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.pageNo = 1;
			this.keywords = '';
			this.isCompany = null;
			this.grade = null
			// this.filterTime = getSearchDate(1).join('/')
			this.initTime()
			this.getList();
		}

		private async getList() {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				Keywords: this.keywords,
				IsCompany: this.isCompany,
				RoleGrade:this.grade,
				ProductIdList:this.shopIdList,
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				params.EndTime = nextDay(dt[1],1);
			}

			this.loading = true;

			try {
				const res: any = await profitStatisticList(params);
				this.list = res.Result.Results
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.loading = false;
			}
		}

		private toDetail(e) {
			// console.log(e)
			// return 
			// this.selected = e;
			// this.visible = true;
			this.$router.push({
				path:'profit-statistic-detail',
				query:{
					Id:e.MemberId,
					Name:encodeURIComponent(e.MemberName),
					RoleGrade:e.RoleGrade,
					SuperId:e.SuperId,
					filterTime:this.filterTime
				}
			})
		}
		
		/**
		 * 导出
		 */
		private exportExcel(){
			var url = location.origin + '/pc/profitStatistic/export?';
			url += 'Keywords=' + (this.keywords?this.keywords:'');
			url += '&IsCompany=' + (this.isCompany!==null?this.isCompany:'');
			url += '&RoleGrade=' + (this.grade!==null?this.grade:'');
			url += '&ProductIdList=' + this.shopIdList
			
			
			if (this.filterTime && this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + nextDay(dt[1],1);
			}
			
			window.open(url)
			
		}
	}
